<p-sidebar [(visible)]="appMain.rightMenuActive" [position]="app.isRTL ? 'left' : 'right'" [blockScroll]="true"
    [showCloseIcon]="false" [baseZIndex]="1000"
    [styleClass]="'layout-rightmenu p-sidebar-sm fs-small p-py-3 ' + (app.isRTL ? 'p-pl-0 p-pr-3' : 'p-pl-3 p-pr-0')">
    <div class="online-members p-d-flex p-flex-column p-mt-3" [ngClass]="{'p-ml-3': !app.isRTL, 'p-mr-3': app.isRTL}">
        <h6 class="header">Preferencias de usuario</h6>
        <div class="p-d-flex p-flex-row p-flex-wrap">

        </div>
        <span class="p-mt-3"><b>+19</b> Store ID</span>
    </div>
    <div class="latest-activity p-d-flex p-flex-column p-mt-6" [ngClass]="{'p-ml-3': !app.isRTL, 'p-mr-3': app.isRTL}">
        <h6 class="header">Perfil</h6>
        <div class="p-d-flex p-flex-row p-pt-2">
            <i class="pi pi-images p-as-start p-p-2" [ngClass]="{'p-mr-2': !app.isRTL, 'p-ml-2': app.isRTL}"></i>
            <div class="p-d-flex p-flex-column">
                <span class="p-text-bold p-mb-1">Lenguaje</span>
                <span class="p-mb-2">Español.</span>
            </div>
        </div>
        <div class="p-d-flex p-flex-row p-pt-3">
            <i class="pi pi-images p-as-start p-p-2" [ngClass]="{'p-mr-2': !app.isRTL, 'p-ml-2': app.isRTL}"></i>
            <div class="p-d-flex p-flex-column">
                <span class="p-text-bold p-mb-1">Coordinación Seleccionada</span>
                <span class="p-mb-2">San Pedro de los Pinos</span>
            </div>
        </div>
        <div class="p-d-flex p-flex-row p-pt-3">
            <i class="pi pi-images p-as-start p-p-2" [ngClass]="{'p-mr-2': !app.isRTL, 'p-ml-2': app.isRTL}"></i>
            <div class="p-d-flex p-flex-column">
                <span class="p-text-bold p-mb-1">Items de navigación</span>
                <span class="p-mb-2">Cuba, Peru</span>
            </div>
        </div>
        <div class="p-d-flex p-flex-row p-pt-3">
            <i class="pi pi-images p-as-start p-p-2" [ngClass]="{'p-mr-2': !app.isRTL, 'p-ml-2': app.isRTL}"></i>
            <div class="p-d-flex p-flex-column">
                <span class="p-text-bold p-mb-1">Moneda Seleccionada</span>
                <span class="p-mb-2">Peso Mexicano</span>
            </div>
        </div>
    </div>
</p-sidebar>